import { Link } from "react-router-dom";
import { Name } from "@app/types/enums";
import { AnnotationComponentProps } from "@pages/Article/components/StoryElements/Annotation/utils/types";
import { getFieldValue } from "@util/helpers";
import { isEmpty } from "lodash-es";

/**
 * Renders an internal link for an annotation component.
 *
 * @param {AnnotationComponentProps} props - The component props.
 * @param {React.ReactNode} props.children - The children of the component.
 * @param {Annotation} props.element - The annotation element.
 * @returns {React.ReactElement} The rendered internal link component.
 */
export default function AnnotationComponentInternalLink({
  children,
  element,
}: AnnotationComponentProps): React.ReactElement {
  const uri = element?.relation?.urlPath;
  const isNewWindow = getFieldValue(element?.fields || [], Name.NewWindow);
  const isNoFollow = getFieldValue(element?.fields || [], Name.NoFollow);

  return (
    <>
      {typeof uri === "string" && !isEmpty(uri) ? (
        <Link
          to={uri}
          target={isNewWindow ? "_blank" : undefined}
          rel={isNoFollow ? "nofollow" : undefined}
          reloadDocument
        >
          {children}
        </Link>
      ) : null}
    </>
  );
}
